import React from 'react';
import ReactDOM from 'react-dom';
import { CATEGORIES, REQUESTERS, STATUSES, USERS } from './data.jsx';
// Shared UI primitives + icons

const Icon = ({ name, size = 14, ...rest }) => {
  const paths = {
    inbox: <><path d="M3 4h14v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4Z"/><path d="M3 9h4l1.5 2h3L13 9h4"/></>,
    user: <><circle cx="10" cy="7" r="3"/><path d="M4 16c1-3 4-4 6-4s5 1 6 4"/></>,
    users: <><circle cx="7" cy="7" r="2.5"/><circle cx="13" cy="7" r="2.5"/><path d="M2 16c.5-2 2.5-3 5-3s4.5 1 5 3M9 16c.5-2 2.5-3 5-3"/></>,
    flag: <path d="M5 3v14M5 4h9l-1.5 3L14 10H5"/>,
    book: <path d="M4 4v12a1 1 0 0 0 1 1h11V4H6a2 2 0 0 0-2 2"/>,
    openBook: <><path d="M2 6l8-2v12L2 14V6Z"/><path d="M18 6l-8-2v12l8-2V6Z"/><path d="M10 4v12"/></>,
    bar: <><path d="M4 16V9"/><path d="M9 16V5"/><path d="M14 16v-5"/><path d="M3 17h14"/></>,
    search: <><circle cx="9" cy="9" r="5"/><path d="m13 13 4 4"/></>,
    plus: <><path d="M10 4v12M4 10h12"/></>,
    check: <path d="m4 10 4 4 8-8"/>,
    chevron: <path d="m6 8 4 4 4-4"/>,
    chevronRight: <path d="m8 5 4 4-4 4 "/>,
    filter: <path d="M3 4h14l-5 7v5l-4 1v-6L3 4Z"/>,
    archive: <><path d="M3 5h14v3H3z"/><path d="M4 8v8h12V8M8 11h4"/></>,
    sparkle: <path d="M10 3v3M10 14v3M3 10h3M14 10h3M5 5l2 2M13 13l2 2M5 15l2-2M13 7l2-2"/>,
    refresh: <><path d="M3 10a7 7 0 0 1 12-5"/><path d="M17 10a7 7 0 0 1-12 5"/><path d="M15 2v4h-4"/><path d="M5 18v-4h4"/></>,
    settings: <><circle cx="10" cy="10" r="2.5"/><path d="M15.4 11.5a1 1 0 0 0 .2 1.1l.05.05a1.2 1.2 0 0 1-1.7 1.7l-.05-.05a1 1 0 0 0-1.1-.2 1 1 0 0 0-.6.9v.15a1.2 1.2 0 0 1-2.4 0V15a1 1 0 0 0-.6-.9 1 1 0 0 0-1.1.2l-.05.05a1.2 1.2 0 0 1-1.7-1.7l.05-.05a1 1 0 0 0 .2-1.1 1 1 0 0 0-.9-.6H5a1.2 1.2 0 0 1 0-2.4h.15a1 1 0 0 0 .9-.6 1 1 0 0 0-.2-1.1L5.8 6.7a1.2 1.2 0 0 1 1.7-1.7l.05.05a1 1 0 0 0 1.1.2h.05a1 1 0 0 0 .6-.9V4a1.2 1.2 0 0 1 2.4 0v.15a1 1 0 0 0 .6.9 1 1 0 0 0 1.1-.2l.05-.05a1.2 1.2 0 0 1 1.7 1.7l-.05.05a1 1 0 0 0-.2 1.1v.05a1 1 0 0 0 .9.6H15a1.2 1.2 0 0 1 0 2.4h-.15a1 1 0 0 0-.9.6z"/></>,
    info: <><circle cx="10" cy="10" r="7.5"/><circle cx="10" cy="6.5" r=".9" fill="currentColor" stroke="none"/><path d="M10 9.5v5"/></>,
    merge: <path d="M6 3v4c0 3-3 5-3 5h14s-3-2-3-5V3M10 12v5M8 17h4"/>,
    link: <path d="M8 12a3 3 0 0 1 0-4l2-2a3 3 0 0 1 4 4l-1 1M12 8a3 3 0 0 1 0 4l-2 2a3 3 0 0 1-4-4l1-1"/>,
    paperclip: <path d="M14 9 8 15a3 3 0 0 1-4-4l7-7a2 2 0 0 1 3 3l-7 7"/>,
    arrowUp: <path d="M10 16V4M5 9l5-5 5 5"/>,
    close: <path d="M5 5l10 10M15 5 5 15"/>,
    dots: <><circle cx="5" cy="10" r="1.2"/><circle cx="10" cy="10" r="1.2"/><circle cx="15" cy="10" r="1.2"/></>,
    tag: <path d="M3 3h7l7 7-7 7-7-7V3M7 7h.01"/>,
    edit: <path d="M4 14V16h2L16 6l-2-2L4 14Z"/>,
    trash: <><path d="M4 6h12M8 6V4h4v2M6 6l1 10h6l1-10"/></>,
    calendar: <><rect x="3" y="5" width="14" height="12" rx="1.5"/><path d="M3 9h14M7 3v4M13 3v4"/></>,
    bookmark: <path d="M5 3h10v14l-5-3-5 3V3Z"/>,
    sortDesc: <path d="M6 4v12M3 12l3 4 3-4M12 5h6M12 9h4M12 13h2"/>,
    mail: <><rect x="3" y="5" width="14" height="10" rx="1"/><path d="m3 6 7 5 7-5"/></>,
    bell: <path d="M5 14V9a5 5 0 0 1 10 0v5l1 2H4l1-2ZM8 17a2 2 0 0 0 4 0"/>,
    grip: <><circle cx="7" cy="5" r=".8"/><circle cx="7" cy="10" r=".8"/><circle cx="7" cy="15" r=".8"/><circle cx="13" cy="5" r=".8"/><circle cx="13" cy="10" r=".8"/><circle cx="13" cy="15" r=".8"/></>,
    eye: <><path d="M2 10s3-5 8-5 8 5 8 5-3 5-8 5-8-5-8-5Z"/><circle cx="10" cy="10" r="2"/></>,
    eyeOff: <><path d="M3 3l14 14"/><path d="M8 4.5C8.6 4.3 9.3 4.2 10 4.2c5 0 8 5 8 5a13 13 0 0 1-2.4 3M5 7.5A13 13 0 0 0 2 9.2s3 5 8 5c1.5 0 2.8-.4 4-1"/></>,
    messageSquare: <path d="M4 4h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7.5L4 17.5V5a1 1 0 0 1 0-1Z"/>,
    home: <path d="M3 10 10 3l7 7M5 9v8h4v-5h2v5h4V9"/>,
    key: <><circle cx="6.5" cy="10" r="3"/><path d="M9.5 10H17M14.5 10v2.5M16.5 10v2"/></>,
  };
  return (
    <svg viewBox="0 0 20 20" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...rest}>
      {paths[name]}
    </svg>
  );
};

if (!window.PHOTO_CACHE)   window.PHOTO_CACHE   = new Map();   // email → url | 'failed'
if (!window.PHOTO_WAITERS) window.PHOTO_WAITERS = new Map();   // email → [setPhotoUrl, ...]

// Only the IT team gets real photos - everyone else falls back to initials.
// See the note in Avatar for why. Precomputed once as a Set for O(1) lookup
// against every Avatar render.
const _IT_PHOTO_EMAILS = new Set(USERS.map(u => u.email.toLowerCase()));

// Rehydrate the negative-result cache from sessionStorage on module load -
// otherwise every page reload re-asks Graph for the same 404 emails (external
// senders, noreply@ addresses, closed accounts). The 'failed' entries are the
// expensive ones because Graph can take 1-2s to return 404 under load; each
// one blocks a connection and there are dozens per page. Successes (blob URLs)
// aren't cached across reloads because the URLs are only valid for the tab.
const _PHOTO_MISS_KEY = 'triage:photo-misses-v1';
try {
  const raw = sessionStorage.getItem(_PHOTO_MISS_KEY);
  if (raw) {
    for (const email of JSON.parse(raw)) window.PHOTO_CACHE.set(email, 'failed');
  }
} catch (_) { /* parse fail - ignore */ }
const _persistMiss = (email) => {
  try {
    const existing = JSON.parse(sessionStorage.getItem(_PHOTO_MISS_KEY) || '[]');
    if (!existing.includes(email)) {
      existing.push(email);
      sessionStorage.setItem(_PHOTO_MISS_KEY, JSON.stringify(existing));
    }
  } catch (_) { /* quota or JSON fail - non-fatal */ }
};

const Avatar = ({ user, size = "" }) => {
  const [photoUrl, setPhotoUrl] = React.useState(null);

  React.useEffect(() => {
    const email = (user?.email || user?.mail || "").toLowerCase();
    if (!email || !window.IT_AUTH) return;

    // Only fetch photos for the 5 IT team members (the USERS list).
    // Requesters - even L&T ones - get initials only. Rationale: on a
    // 318-row tickets list every row has an avatar for the requester AND
    // the assignee. Fetching every unique L&T requester's photo was firing
    // 15-20 Graph requests per page (~2s of parallel work + JS blob/URL
    // creation per response). Assignees are always in USERS, so IT-team
    // avatars still render with photos; everyone else is a coloured
    // initials circle - same pattern most SaaS list views use. If we ever
    // want photos back for requesters, do it lazily on hover / detail-view
    // open, not on the list.
    if (!_IT_PHOTO_EMAILS.has(email)) {
      window.PHOTO_CACHE.set(email, 'failed');
      return;
    }

    // Already resolved - use immediately
    const cached = window.PHOTO_CACHE.get(email);
    if (cached && cached !== 'failed') { setPhotoUrl(cached); return; }
    if (cached === 'failed') return;

    // Another Avatar is already fetching - register as a waiter
    if (window.PHOTO_WAITERS.has(email)) {
      window.PHOTO_WAITERS.get(email).push(setPhotoUrl);
      return;
    }

    // First fetcher - register ourselves and kick off the request
    window.PHOTO_WAITERS.set(email, [setPhotoUrl]);

    const activeAccount = window.IT_AUTH.getActiveAccount();
    const selfUpn  = (activeAccount?.username || "").toLowerCase();
    const selfMail = (activeAccount?.idTokenClaims?.email || "").toLowerCase();
    const isSelf   = email === selfUpn || email === selfMail;
    const endpoint = isSelf
      ? 'https://graph.microsoft.com/v1.0/me/photo/$value'
      : `https://graph.microsoft.com/v1.0/users/${encodeURIComponent(email)}/photo/$value`;

    window.IT_AUTH.getToken().then(token =>
      fetch(endpoint, { headers: { Authorization: `Bearer ${token}` } })
    ).then(res => {
      if (!res.ok) throw new Error('no photo');
      return res.blob();
    }).then(blob => {
      const url = URL.createObjectURL(blob);
      window.PHOTO_CACHE.set(email, url);
      (window.PHOTO_WAITERS.get(email) || []).forEach(fn => fn(url));
      window.PHOTO_WAITERS.delete(email);
    }).catch(() => {
      window.PHOTO_CACHE.set(email, 'failed');
      _persistMiss(email);
      window.PHOTO_WAITERS.delete(email);
    });
  }, [(user?.email || user?.mail || "").toLowerCase()]);

  if (!user) return <div className={`av empty ${size}`}>-</div>;
  const initials = user.initials || (user.name||"?").split(" ").map(s=>s[0]).slice(0,2).join("");
  if (photoUrl) {
    return <div className={`av ${size}`} style={{background: user.color, padding: 0, overflow: "hidden"}}><img src={photoUrl} alt={user.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/></div>;
  }
  return <div className={`av ${size}`} style={{background: user.color}}>{initials}</div>;
};

const StatusChip = ({ status }) => {
  const s = STATUSES.find(x => x.id === status) || STATUSES[0];
  return <span className="status-chip"><span className={`dot ${s.tone}`}/>{s.label}</span>;
};

const PriorityChip = ({ priority }) => {
  if (!priority) return null;
  const labels = { urgent: "Urgent", high: "High", medium: "Medium", low: "Low" };
  return <span className={`pri pri-${priority}`}>{labels[priority]}</span>;
};

const PriorityBar = ({ priority }) => {
  if (!priority) return <span className="pri-bar" style={{background:"transparent"}}/>;
  return <span className={`pri-bar ${priority}`}/>;
};

const fmtTime = (mins) => {
  const m = Math.abs(mins);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m`;
  if (m < 60 * 24) return `${Math.floor(m / 60)}h`;
  if (m < 60 * 24 * 7) return `${Math.floor(m / 60 / 24)}d`;
  return `${Math.floor(m / 60 / 24 / 7)}w`;
};

// Accepts either an ISO timestamp string (preferred - actual server-side
// wall-clock time, no arithmetic across clocks) or a legacy "minutes ago"
// number that gets applied to the client's clock. String path is exact;
// number path is subject to any drift between client and server clocks
// and is only kept for pre-migration data still in flight.
const fmtDate = (input) => {
  if (input == null) return "";
  let d;
  if (typeof input === "string") {
    d = new Date(input);
  } else {
    d = new Date(Date.now() + input * 60 * 1000);
  }
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", { day:"numeric", month:"short" }) + " · " + d.toLocaleTimeString("en-GB", { hour:"2-digit", minute:"2-digit" });
};

// Lookup helpers
const getUser = (id) => USERS.find(u => u.id === id);
const getRequester = (emailOrId) => {
  if (window.STAFF_LIST) {
    const s = window.STAFF_LIST.find(u => u.mail === emailOrId);
    if (s) return {
      name: s.displayName, email: s.mail, dept: s.department || "",
      color: "#888",
      initials: s.displayName.split(" ").filter(Boolean).map(n => n[0]).join("").slice(0,2).toUpperCase(),
    };
  }
  const fromReq = REQUESTERS.find(u => u.id === emailOrId);
  if (fromReq) return fromReq;
  // Email address not in staff list - show as unknown
  return { name: emailOrId || "Unknown", email: emailOrId || "", dept: "", color: "#94A3B8", initials: "?" };
};
const getCategory = (id) => CATEGORIES.find(c => c.id === id);

// Popover positioned beside anchor; clamps to viewport on both axes.
// Portalled to document.body - otherwise, when the parent has a CSS
// transform (as .sel-bar does, transform: translateX(-50%)), that parent
// becomes the containing block for our position:fixed backdrop and popover,
// and the top/left values we compute from getBoundingClientRect (viewport
// coords) get re-interpreted as offsets from the parent instead. The whole
// popover then renders off-screen and the user sees "clicking the button
// does nothing". Bug reported by Alex 17 Jun 2026 - same class of trap the
// cross-subject merge modal already sidesteps via portal.
const Popover = ({ anchorRef, onClose, children, align = "left" }) => {
  const popRef = React.useRef();
  const [pos, setPos] = React.useState({ top: -9999, left: -9999, maxHeight: undefined, visibility: "hidden" });
  React.useLayoutEffect(() => {
    if (!anchorRef.current || !popRef.current) return;
    const r = anchorRef.current.getBoundingClientRect();
    const popW = popRef.current.offsetWidth || 220;
    const popH = popRef.current.offsetHeight || 250;
    const vw = window.innerWidth, vh = window.innerHeight;
    let left = align === "right" ? r.right - popW : r.left;
    if (left + popW > vw - 8) left = vw - popW - 8;
    if (left < 8) left = 8;
    const spaceBelow = vh - r.bottom - 8;
    const spaceAbove = r.top - 8;
    let top, maxHeight;
    if (popH <= spaceBelow || spaceBelow >= spaceAbove) {
      top = r.bottom + 4;
      maxHeight = spaceBelow;
    } else {
      top = Math.max(8, r.top - Math.min(popH, spaceAbove) - 4);
      maxHeight = spaceAbove;
    }
    setPos({ top, left, maxHeight, visibility: "visible" });
  }, []);
  return ReactDOM.createPortal(
    <>
      <div className="backdrop" onClick={onClose}/>
      <div
        ref={popRef}
        className="popover"
        style={{top: pos.top, left: pos.left, maxHeight: pos.maxHeight, visibility: pos.visibility}}
      >
        {children}
      </div>
    </>,
    document.body
  );
};

export {
  Icon, Avatar, StatusChip, PriorityChip, PriorityBar,
  fmtTime, fmtDate, getUser, getRequester, getCategory,
  Popover,
};
